import store from "../redux/store";
import { wsMsgSeparatorChar } from './websocketHelper';
import { updateIndexInfos, updateIndexChart, updateBasketIndex, updateStatisticChart, updateDerivativeChart } from '../redux/actions/indexActions';

const arrColor = [
    "", // None
    "clr-ceil",
    "clr-floor",
    "clr-ref",
    "clr-down",
    "clr-up"
];

const arrIndexMsgField =[
    "indexCode", //0
    "indexName",
    "typeIndex",
    "priorIndex",
    "currentIndex",
    "changeIndex", //5
    "pctChangeIndex",
    "highestIndex",
    "lowestIndex",
    "closeIndex",
    "totalTradedQtty", //10
    "totalTradedValue",
    "totalTradedQttyNM",
    "totalTradedValueNM",
    "totalTradedQttyPT",
    "totalTradedValuePT", // 15
    "totalStock",
    "up",
    "upCeil",
    "noChange",
    "down", //20
    "downFloor",
    "status",
    "statusStr",
    "statusStrEn",
    "buyForeignQtty", //25
    "buyForeignValue",
    "sellForeignQtty",
    "sellForeignValue",
    "totalTradedQttyUp",
    "totalTradedValueUp", //30
    "totalTradedQttyDown",
    "totalTradedValueDown",
    "totalTradedQttyNoChange",
    "totalTradedValueNoChange",
    "priceRatioChange", //35
    "subForeignQtty",
    "subForeignValue",
    "openIndex",
    "marketCode",
    "marketName", //40
    "marketNameEn"
];

export const ClearAllIndexChart = () => {
    store.dispatch(updateIndexChart({}));
    store.dispatch(updateStatisticChart({}));
}

export const ProcessMsgIndex = (message, isInit) => {
    try {
        // gIndex.indexInfos
        
        let _oldDatas = store.getState().gIndex.indexInfos;
        let _recvMsgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
        for (let _indexIdx = 0; _indexIdx < _recvMsgs.length; _indexIdx++) {
            const _recvInfo = _recvMsgs[_indexIdx];
            if(_recvInfo !== "") {
                const _firstIdx = _recvInfo.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
                const _code = _recvInfo.substr(0, _firstIdx);
                let _rIndex = _oldDatas.findIndex((item) => item.indexCode === _code);
                if (_rIndex < 0) {
                    isInit = true;
                    _oldDatas.push({ indexCode: _code, counter: 0 });
                    _rIndex = _oldDatas.length - 1;
                }
                //
                let _objTemp = _oldDatas[_rIndex];
                let _changed = false;
                const _arrData = _recvInfo.substr(_firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
                for (let _dataIdx = 0; _dataIdx < _arrData.length; _dataIdx++) {
                    if(_arrData[_dataIdx] !== "") {
                        let _arrSubData = _arrData[_dataIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                        const _propIndex = Number(_arrSubData[0]);
                        if(_propIndex < arrIndexMsgField.length) {
                            let _objProp = arrIndexMsgField[_propIndex];
                            _objTemp[_objProp] = _arrSubData[1];
                            if(_arrSubData.length >= 3) {
                                _objTemp[_objProp + "_color"] = arrColor[Number(_arrSubData[2])];
                            }
                            _changed = true;
                        }
                    }
                }
                //
                if (_changed) {
                    _objTemp.counter = _objTemp.counter + 1;
                }
                //
                _oldDatas[_rIndex] = _objTemp;
            }
        }
        //
        store.dispatch(updateIndexInfos(_oldDatas, isInit));
    } catch (error) {
    }
}

//
export const ProcessMsgIndexChart = (message) => {
    try {
        // gIndex.indexChart
        if(message === undefined || message === null || message === "") {
            return;
        }

        //
        let storedDataChartInfos = store.getState().gIndex.indexChart ?? {};
        let msgInfos = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);

        //
        for (let mIdx = 0; mIdx < msgInfos.length; mIdx++) {
            const msg = msgInfos[mIdx];
            if(msg === "") {
                continue;
            }
            //
            const firstIdx = msg.indexOf(wsMsgSeparatorChar.PropSeparatorChar);

            if(firstIdx < 0) {
                continue;
            }
            const indexCode = msg.substr(0, firstIdx);
            if(indexCode === "") {
                continue;
            }


            //
            let storedDatasByIndexCode = storedDataChartInfos[indexCode] ?? { counter: 0, datas: [] }; //{ counter: 0, datas: [{time: 0, value: 0, quantity: 0, priceRatioChange: 0, isTemp: Y/N},...] }
            // console.log(storedDatasByIndexCode, "storedDatasByIndexCodestoredDatasByIndexCode");
            const msgDatasByTime = msg.substr(firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
            // console.log(msgDatasByTime, "aaaa12");

            for (let dIdx = 0; dIdx < msgDatasByTime.length; dIdx++) {
                if(msgDatasByTime[dIdx] === "") {
                    continue;
                }
                //
                const propDatas = msgDatasByTime[dIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                const time = Number(propDatas[0]);
                let datas = storedDatasByIndexCode.datas ?? [];
                const idx = datas.findIndex((el) => el.time === time);
                if(idx < 0) {
                    datas.push({
                        time: time,
                        value: Number(propDatas[1]),
                        quantity: Number(propDatas[2]),
                        priceRatioChange: Number(propDatas[3]),
                        isTemp: propDatas.length >= 5 ? propDatas[4] : '',
                    });
                }
                else {
                    datas[idx].value = Number(propDatas[1]);
                    datas[idx].quantity = Number(propDatas[2]);
                    datas[idx].priceRatioChange = Number(propDatas[3]);
                    datas[idx].isTemp = propDatas.length >= 5 ? propDatas[4] : '';
                }
                //
                storedDatasByIndexCode.datas = datas;
                storedDatasByIndexCode.counter += 1;
            }
            //
            storedDataChartInfos[indexCode] = storedDatasByIndexCode;
        }
        //
        store.dispatch(updateIndexChart(storedDataChartInfos));
    } catch (error) {
        console.log("ProcessMsgIndexChart", error);
    }
}

//
export const ProcessMsgIndex30Symbol = (message) => {
    try {
        //VN30*ACB,HPG,...|HNX30*BVS,CAP,...|...
        if(message === undefined || message === null || message === "") {
            return;
        }
        //
        let storedDatas = store.getState().gIndex.basketIndex ?? {};
        let msgInfos = message.split(wsMsgSeparatorChar.PropSeparatorChar);
        //
        for (let mIdx = 0; mIdx < msgInfos.length; mIdx++) {
            const msg = msgInfos[mIdx];
            if(msg === "") {
                continue;
            }
            //
            const msgDatas = msg.split(wsMsgSeparatorChar.DataSeparatorChar);
            if(msgDatas.length === 2) {
                storedDatas[msgDatas[0]] = msgDatas[1];
            }
        }
        //
        store.dispatch(updateBasketIndex(storedDatas));
    } catch (error) {
        console.log("ProcessMsgIndex30Symbol", error);
    }
}

//
export const ProcessMsgIndexStatisticChart = (message) => {
    try {
        if(message === undefined || message === null || message === "") {
            return;
        }
        //
        let storedDatas = store.getState().gIndex.statisticChart ?? {};
        const statisticInfos = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
        for (let mIdx = 0; mIdx < statisticInfos.length; mIdx++) {
            const statisticInfo = statisticInfos[mIdx];
            if(statisticInfo === '') {
                continue;
            }
            const firstIdx = statisticInfo.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            if(firstIdx < 0) {
                continue;
            }
            const indexCode = statisticInfo.substr(0, firstIdx);
            //
            let storedDataByCode = storedDatas[indexCode] ?? { counter: 0, datas: [] }; // { counter: 0, datas: [{ time: 0, open: 0, close: 0, lowest: 0, highest: 0, volume: 0 }, ...]}
            const dataByTimes = statisticInfo.substr(firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
            for (let dIdx = 0; dIdx < dataByTimes.length; dIdx++) {
                if(dataByTimes[dIdx] === '') {
                    continue;
                }
                
                const propDatas = dataByTimes[dIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                const time = Number(propDatas[0]);
                let datas = storedDataByCode.datas ?? [];
                const idx = datas.findIndex((el) => el.time === time);
                if(idx < 0) {
                    datas.push({ 
                        time: time, 
                        open: Number(propDatas[1]),
                        close: Number(propDatas[2]),
                        lowest: Number(propDatas[3]),
                        highest: Number(propDatas[4]),
                        volume: Number(propDatas[5])
                    });
                }
                else {
                    datas[idx].open = Number(propDatas[1]);
                    datas[idx].close = Number(propDatas[2]);
                    datas[idx].lowest = Number(propDatas[3]);
                    datas[idx].highest = Number(propDatas[4]);
                    datas[idx].volume = Number(propDatas[5]);
                }
                //
                storedDataByCode.datas = datas;
                storedDataByCode.counter = storedDataByCode.counter + 1;
            }
            //
            storedDatas[indexCode] = storedDataByCode;
        }
        //
        store.dispatch(updateStatisticChart(storedDatas));
    } catch (error) {
        console.log("ProcessMsgIndexStatisticChart", error);
    }
}

// 
export const ProcessMsgIndexForeignTradeHistChart = (message) => {
    try {
        if(message === undefined || message === null || message === "") {
            return;
        }
        //
        let _storedIndexInfos = store.getState().gIndex.indexInfos;
        let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
        for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
            if (_msgs[_msgIdx] !== "") {
                const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
                const _indexCode = _msgs[_msgIdx].substr(0, _firstIdx);
                let _rIndex = _storedIndexInfos.findIndex((item) => item.indexCode === _indexCode);
                if (_rIndex < 0) {
                    continue;
                }
                //
                let _objTemp = _storedIndexInfos[_rIndex];
                _objTemp.foreignTradeHistChart =_msgs[_msgIdx].substr(_firstIdx);
                _objTemp.counter = _objTemp.counter + 1;
                //
                _storedIndexInfos[_rIndex] = _objTemp;
            }
        }
        //
        store.dispatch(updateIndexInfos(_storedIndexInfos, false));
    } catch (error) {
    }
}

export const ProcessMsgIndexDerivativeChart = (message) => {
    try {
        if(message === undefined || message === null || message === "") {
            return;
        }
        //
        let _storedDerivativeInfos = store.getState().gIndex.derivativeChart;

        // console.log(_storedDerivativeInfos, "_storedDerivativeInfos_storedDerivativeInfos");
        // let _msgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);
        // for (let _msgIdx = 0; _msgIdx < _msgs.length; _msgIdx++) {
        //     if (_msgs[_msgIdx] !== "") {
        //         const _firstIdx = _msgs[_msgIdx].indexOf(wsMsgSeparatorChar.PropSeparatorChar);
        //         const _indexCode = _msgs[_msgIdx].substr(0, _firstIdx);
        //         let _rIndex = _storedDerivativeInfos.findIndex((item) => item.indexCode === _indexCode);
        //         if (_rIndex < 0) {
        //             continue;
        //         }
        //         //
        //         let _objTemp = _storedDerivativeInfos[_rIndex];
        //         _objTemp.foreignTradeHistChart =_msgs[_msgIdx].substr(_firstIdx);
        //         _objTemp.counter = _objTemp.counter + 1;
        //         //
        //         _storedDerivativeInfos[_rIndex] = _objTemp;
        //     }
        // }
        
        // store.dispatch(updateIndexInfos(_storedIndexInfos, false));
        store.dispatch(updateDerivativeChart(_storedDerivativeInfos));
    } catch (error) {
    }
}